export const BUSINESSES_ACTIONS = {
    SET_BUSINESSES: 'SET_BUSINESSES',
    SET_BUSINESS: 'SET_BUSINESS',
    SHOW_APPROVAL_MODAL: 'SHOW_APPROVAL_MODAL',
    HIDE_APPROVAL_MODAL: 'HIDE_APPROVAL_MODAL',
    SHOW_REJECT_MODAL: 'SHOW_REJECT_MODAL',
    HIDE_REJECT_MODAL: 'HIDE_REJECT_MODAL',
    RELOAD_BUSINESSES: 'RELOAD_BUSINESSES'
};

export default function businessesReducer(state, action) {
    switch (action.type) {
        case BUSINESSES_ACTIONS.SET_BUSINESSES:
            return { ...state, businesses: action.payload };
        case BUSINESSES_ACTIONS.SET_BUSINESS:
            return { ...state, selectedBusiness: action.payload };
        case BUSINESSES_ACTIONS.SHOW_APPROVAL_MODAL:
            return { ...state, isApproveModalOpen: true };
        case BUSINESSES_ACTIONS.HIDE_APPROVAL_MODAL:
            return { ...state, isApproveModalOpen: false };
        case BUSINESSES_ACTIONS.SHOW_REJECT_MODAL:
            return { ...state, isRejectModalOpen: true };
        case BUSINESSES_ACTIONS.HIDE_REJECT_MODAL:
            return { ...state, isRejectModalOpen: false };
        case BUSINESSES_ACTIONS.RELOAD_BUSINESSES:
            return { ...state, reloadBusinesses: state.reloadBusinesses + 1 };
        default:
            throw new Error(`Unhandled action type: ${action.type}`);
    }
}
